module.exports = {"httpFetchErrorInformation":"读取系统数据失败, 请稍后再试或者联系管理员","httpSaveErrorInformation":"保存数据失败, 请稍后再试或者联系管理员","prod":false}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 29
// module chunks = 0